import MaintenanceDetailObservations from "./MaintenanceDetailObservations";
export default MaintenanceDetailObservations;
